<ng-container>
  <a class="user-settings-shortcut" routerLink="/settings/my-entitlements">
    My Subscription
  </a>
  <a class="user-settings-shortcut" routerLink="/settings/my-notifications">
    My Notifications
  </a>
</ng-container>